import { find, get, every } from 'lodash';

import config from '../../config';
import { AUTH_SET_USER } from '../auth/constants';
import { SHOP_TYPE } from '../main/shops/constants';
import { getIsAdminUser } from '../auth/selectors';
import { persistentKVStore } from '../../modules/infra/persistence';
import { FullstoryService } from '../../modules/infra/observability/fullstory';

const analyticsMiddleware = (store) => next => (action) => {
  next(action);
  switch (action.type) {
    case AUTH_SET_USER: {
      if (config.analytics.Fullstory.orgId) {
        const { user } = action;

        const isAdmin = getIsAdminUser(store.getState());
        if (isAdmin) {
          FullstoryService.identify(user.id, {
            role: 'admin',
            email: user.username,
          });
        }

        const activeBarber = get(user, 'barbers[0]');
        const brand = user.brand;
        const activeShopId = persistentKVStore.getItem('shop');
        const activeShop = find(user.shops, { id: activeShopId }) || get(activeBarber, 'shop') || get(user, 'shops[0]');

        const isBrandView = !!user.brand && !activeShopId;
        if (isBrandView) {
          const areAllShopsRental = every(user.shops, shop => shop.kind === SHOP_TYPE.rental);
          const areAllShopsCommission = every(user.shops, shop => shop.kind === SHOP_TYPE.commission);

          let userType = 'mixed';

          if (areAllShopsCommission) {
            userType = 'Commission';
          }

          if (areAllShopsRental) {
            userType = 'Rental';
          }

          FullstoryService.identify(user.id, {
            userType,
            role: 'brand',
            shop: brand.name,
            email: brand.email,
            impersonated: isAdmin,
            brandId: brand.id,
          });
        }

        const isShopView = !isBrandView && !!activeShop && !activeBarber;
        if (isShopView) {
          FullstoryService.identify(user.id, {
            userType: activeShop.kind === SHOP_TYPE.rental ? 'Rental' : 'Commission',
            role: 'shop',
            shop: activeShop.name,
            email: activeShop.email,
            impersonated: isAdmin,
            brandId: activeShop.brandId,
          });
        }

        const isBarberView = !!activeShop && !!activeBarber;
        if (isBarberView) {
          FullstoryService.identify(user.id, {
            userType: activeShop.kind === SHOP_TYPE.rental ? 'Rental' : 'Commission',
            role: 'barber',
            shop: activeShop.name,
            email: activeBarber.email,
            name: activeBarber.firstName,
            impersonated: isAdmin,
            brandId: activeShop.brandId,
          });
        }
      }

      break;
    }
    default:
      break;
  }
};

export default analyticsMiddleware;
